import { render, staticRenderFns } from "./btn.vue?vue&type=template&id=19739a56"
import script from "./btn.vue?vue&type=script&lang=ts"
export * from "./btn.vue?vue&type=script&lang=ts"
import style0 from "./btn.vue?vue&type=style&index=0&id=19739a56&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports